module.exports = __webpack_public_path__ + "static/seo-skilent-9375901b0683db203812a950062e7a69.png";